import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RappiderJsonataEditorComponent } from './jsonata-editor.component';
import { FormsModule } from '@angular/forms';
import { RappiderMonacoEditorModule } from '../monaco-editor/monaco-editor.module';

@NgModule({
  declarations: [
    RappiderJsonataEditorComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RappiderMonacoEditorModule
  ],
  exports: [
    RappiderJsonataEditorComponent
  ]
})
export class RappiderJsonataEditorModule { }
